class StickyAnnouncement extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.announcement = document.querySelector('.shopify-section-ff-announcement-bar');
    this.announcementBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.announcementBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.announcement);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.announcementBounds.bottom) {
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.announcementBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.announcementBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }
  hide() {
    this.announcement.classList.add('shopify-section-announcement-sticky');
  }

  reveal() {
    this.announcement.classList.add('shopify-section-announcement-sticky', 'animate');
  }

  reset() {
    this.announcement.classList.remove('shopify-section-announcement-sticky', 'animate');
  }

}
customElements.define('sticky-announcement', StickyAnnouncement);
